import { useEffect, useRef } from 'react';
import { Icon } from '../components/ui/Icon';
import { SettingsPanel } from './SettingsPanel';

/** Reference settings sheet: tinted from the note colour, title centred, round ✕ at the top right. */
export function SettingsSheet({ open, onClose, onNoteOptions, onNewPage }: { open: boolean; onClose: () => void; onNoteOptions?: () => void; onNewPage?: () => void }) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const prev = document.activeElement as HTMLElement | null;
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !document.querySelector('.sheet-root, .confirm-root')) onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
      prev?.focus?.();
    };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="settings-sheet-root no-print">
      <div className="sheet-scrim" onClick={onClose} aria-hidden="true" />
      <div className="settings-sheet" role="dialog" aria-modal="true" aria-labelledby="settings-title">
        <div className="settings-sheet-head">
          <h2 id="settings-title">Settings</h2>
          <button ref={closeRef} type="button" className="settings-close" aria-label="Close settings" onClick={onClose}>
            <Icon name="close" size={28} strokeWidth={2.6} />
          </button>
        </div>
        <div className="settings-scroll">
          <SettingsPanel onClose={onClose} onNoteOptions={onNoteOptions} onNewPage={onNewPage} />
        </div>
      </div>
    </div>
  );
}
